import CustomTable from "Component/CustomTable";
import { useState, useEffect, useRef, useMemo } from "react";
import { Notify } from "Component/Notify";
import { fetchApi } from "Config/fetchApi";
import { DraggableModal } from "Component/Modal/index";
import { Button, TablePagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "Route/ConstantRoute";
import moment from "moment";
import { EncryptStorage } from "encrypt-storage";
import ReportCustemTable from "Component/CustomTable/reportCustemTable";
import ReportCustemTableDetails from "Component/CustomTable/reportCustemTableDetails";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import PdfDownloadButton from "../pdf/PdfDownloadButton";
import { useDispatch, useSelector } from "react-redux";
import { getMasterGender, getMasterNationality } from "slice/masterSlice";
import isEqual from "lodash/isEqual";
import FilterCustemTable from "Component/CustomTable/filterCustemTable";
import { type } from "@testing-library/user-event/dist/type";
import { ubahStripKeSpasi } from "DashboardManagementPlatform/Helper";
import { getMasterOrganisasi } from "slice/masterSlice";

function Report() {
  const dispatch = useDispatch();
  const encryptStorage = new EncryptStorage(process.env.REACT_APP_SECRET_KEY);
  const isFiltersInitialized = useRef(false);
  const isFiltersInitializedDetail = useRef(false);
  const userInfo = encryptStorage.getItem("___info");
  const yuridiksi_user_code = userInfo?.jurisdiction_level_code || "";
  const permission_flag =
    userInfo?.permission_flag != undefined
      ? JSON.parse(userInfo?.permission_flag)
      : {};
  const organisasi_user_id = userInfo?.organization_id || "";
  const navigate = useNavigate();
  // ==================== Pengaturan Modal ==================== //
  const [openModal, setOpenModal] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  // ==================== Pengaturan Modal ==================== //
  const { datamasterOrganisasi, isLoadingmasterOrganisasi } = useSelector(
    (state) => state.master.master
  );

  const [uuid, setUuid] = useState("");
  const [error, setError] = useState(false);
  const [detailData, setDetailData] = useState({});
  const [keywordSearch, setDataKeyword] = useState("");
  const [keywordSearchDetail, setDataKeywordDetail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});
  const [dataDetail, setDataDetail] = useState({});
  const [filterReports, setFilterReports] = useState([]);
  const [filters, setFilters] = useState([]);
  const [headerTableCustem] = useState([
    {
      label: "Nama Kamera",
      key: "name_camera",
      align: "left",
    },
    {
      label: "Report",
      key: "is_bwc",
      align: "left",
    },
    {
      label: "Organisasi Penanggung Jawab",
      key: "report_organization",
      align: "left",
    },
    // {
    //   label: "Tanggal Report Kamera Dibuat",
    //   key: "report_date",
    //   align: "center",
    // },
  ]);
  const [headerTable] = useState([
    {
      label: "Nama",
      key: "nama_target",
      align: "center",
    },
    {
      label: "Nik",
      key: "nik_target",
      align: "center",
    },
    {
      label: "Gender",
      key: "gender_target",
      align: "center",
    },
    {
      label: "Gambar Crop",
      key: "crop_image",
      align: "center",
    },
    {
      label: "Gambar Target",
      key: "person_face",
      align: "center",
    },
    {
      label: "Similarity",
      key: "similarity",
      align: "center",
    },
    {
      label: "IsDpo",
      key: "is_dpo",
      align: "center",
    },
    {
      label: "Tanggal Report",
      key: "dateDetected",
      align: "center",
    },
  ]);
  const [isActionTable] = useState({
    isAdd: false,
    isEdit: false,
    isShow: false,
    isDelete: false,
    isSearch: false,
  });
  const [isActionTableReport] = useState({
    isAdd: false,
    isEdit: false,
    isShow: true,
    isDelete: false,
  });

  // ==================== Pengaturan Pagination ==================== //
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [pageNumberDetail, setPageNumberDetail] = useState(0);
  const [pageSizeDetail, setPageSizeDetail] = useState(5);
  // ==================== Pengaturan Pagination ==================== //

  const datafilters = useMemo(() => {
    const organisasiField = {
      key: "organisasiPenanggungJawab",
      label: "Organisasi Penanggung Jawab",
      isLoading: false,
      options: [],
      multiple: false,
      value: null,
    };

    const baseFilters = [
      {
        key: "is_bwc",
        label: "Tipe Report",
        isLoading: false,
        options: [],
        multiple: false,
        value: null,
      },
      // {
      //   key: "fromDate",
      //   label: "Start Date",
      //   type: "date",
      //   isLoading: false,
      //   options: null,
      //   multiple: false,
      //   value: null,
      // },
      // {
      //   key: "toDate",
      //   label: "End Date",
      //   type: "date",
      //   isLoading: false,
      //   options: null,
      //   multiple: false,
      //   value: null,
      // },
    ];

    if (yuridiksi_user_code === "N") {
      // Sisipkan field organisasi di urutan ke-2
      return baseFilters
        .slice(0, 1)
        .concat(organisasiField)
        .concat(baseFilters.slice(1));
    }

    return baseFilters;
  }, [yuridiksi_user_code]);

  // ==================== Default ==================== //
  const handleSuccess = (message) => {
    Notify.success({
      title: "Berhasil",
      description: message,
    });
  };
  const handleError = (error) => {
    Notify.error({
      title: "Gagal",
      description: error?.response?.data?.message,
    });
  };
  const getData = async () => {
    try {
      setIsLoading(true);

      const valueTipeReport =
        filters[0]?.value?.value === undefined ? "" : filters[0]?.value?.value;
      const valueOrganisasi =
        filters[1]?.value?.value === undefined ? "" : filters[1]?.value?.value;
      // const valueReportFromDate =
      //   filters[2]?.value?.value === undefined ? "" : filters[2]?.value?.value;
      // const valueReportToDate =
      //   filters[3]?.value?.value === undefined ? "" : filters[3]?.value?.value;

      const paramCari = `keywordPencarian=${keywordSearch}`;
      const paramPage = `page=${pageNumber}`;
      const paramSize = `size=${pageSize}`;
      const organizationParam = `organizationId=${yuridiksi_user_code === "N" ? valueOrganisasi : organisasi_user_id}`;
      const reportTypeParam = `is_bwc=${valueTipeReport}`;
      // const reportFromDateParam = `fromDate=${valueReportFromDate}`;
      // const reportToDateParam = `toDate=${valueReportToDate}`;
      const response = await fetchApi().get(
        `/reports/get-list?${paramCari}&${organizationParam}&${reportTypeParam}&${paramPage}&${paramSize}`
        // `/reports/get-list?${paramCari}&${organizationParam}&${reportTypeParam}&${reportFromDateParam}&${reportToDateParam}&${paramPage}&${paramSize}`
      );
      // reports/get-list?keywordPencarian=a&organizationId=a08bdf9f-2e0e-417e-b571-94aa1d9edb79&is_bwc=true&fromDate=2025-04-21T18%3A05%3A40.669%2B00%3A00&toDate=2025-04-24T03%3A30%3A17.759%2B00%3A00&page=0&size=20

      setData(response?.data || {});
      setPageNumber(response.data?.currentPage || 0);
      setPageSize(response.data?.size || 15);
      setIsLoading(false);
    } catch (err) {
      setData([]);
      setIsLoading(false);
      handleError(err);
    }
  };

  let valueStartDate =
    filterReports[0]?.value === undefined ? null : filterReports[0]?.value;
  let valueEndDate =
    filterReports[1]?.value === undefined ? null : filterReports[1]?.value;
  let valueIsDpo =
    filterReports[2]?.value?.value === undefined
      ? ""
      : filterReports[2]?.value?.value;
  const getDataDetails = async () => {
    try {
      setIsLoading(true);

      const paramCari = `keywords=${keywordSearchDetail}`;
      const paramPage = `page=${pageNumberDetail}`;
      const paramSize = `size=${pageSizeDetail}`;
      const paramisDpo = `isDpo=${valueIsDpo}`;
      const paramstartDate = `startDate=${valueStartDate}`;
      const paramendDate = `endDate=${valueEndDate}`;
      const organizationParam = `organizationId=${yuridiksi_user_code === "N" ? "" : organisasi_user_id}`;

      let route;
      if (valueStartDate && valueEndDate) {
        route = `/report-detected-target/get-report-detected?reportUuid=${detailData?.uuid}&${paramisDpo}&${paramCari}&${paramstartDate}&${paramendDate}&${paramPage}&${paramSize}`;
      } else {
        route = `/report-detected-target/get-report-detected?reportUuid=${detailData?.uuid}&${paramisDpo}&${paramCari}&${paramPage}&${paramSize}`;
      }

      const response = await fetchApi().get(route);
      // const response = await fetchApi().get(
      //   `/report-detected-target/get-report-detected?reportUuid=${detailData?.uuid}&${paramisDpo}&${paramCari}&=${paramstartDate}$${paramendDate}&${paramPage}&${paramSize}`
      // );
      setDataDetail(response?.data || {});
      setPageNumberDetail(response.data?.currentPage || 0);
      setPageSizeDetail(response.data?.size || 15);
      setIsLoading(false);
      setError(false);
    } catch (err) {
      setError(true);
      setDataDetail([]);
      setIsLoading(false);
      handleError(err);
    }
  };
  const deleteData = async () => {
    try {
      setIsLoading(true);
      const response = await fetchApi().delete(`/operation/delete/${uuid}`);
      setIsLoading(false);
      handleSuccess(response.data?.message);
      getData();
      setOpenModalDelete(!openModalDelete);
    } catch (err) {
      setOpenModalDelete(!openModalDelete);
      setIsLoading(false);
      handleError(err);
    }
  };
  // ==================== Default ==================== //

  useEffect(() => {
    if (isFiltersInitialized.current) {
      getData();
    }
  }, [keywordSearch, pageNumber, pageSize, filters]);

  useEffect(() => {
    if (openModal && isFiltersInitializedDetail.current) {
      if (
        (valueStartDate === null && valueEndDate === null) ||
        (valueStartDate !== null && valueEndDate !== null)
      ) {
        getDataDetails();
      }
    } else {
      const reset = filterReports.map((f) => ({
        ...f,
        value: f.multiple ? [] : null,
      }));
      if (!isEqual(filterReports, reset)) {
        setFilterReports(reset);
      }
    }
  }, [
    openModal,
    filterReports,
    pageNumberDetail,
    pageSizeDetail,
    valueStartDate,
    valueEndDate,
  ]);
  // ==================== Default ==================== //
  const datafilterReports = useMemo(() => {
    const baseFilterReports = [
      {
        key: "startDate",
        label: "Start Date",
        type: "date",
        isLoading: false,
        options: null,
        multiple: false,
        value: null,
      },
      {
        key: "endDate",
        label: "End Date",
        type: "date",
        isLoading: false,
        options: null,
        multiple: false,
        value: null,
      },
      {
        key: "is_active",
        type: "autocomplite",
        label: "IsDpo",
        isLoading: false,
        options:
          [
            { label: "DPO", value: true },
            { label: "NON DPO", value: false },
            // { label: "All", value: null },
          ] || [],
        multiple: false,
        value: null,
      },
    ];

    return baseFilterReports;
  }, []);

  useEffect(() => {
    if (datafilterReports.length > 0 && !isFiltersInitializedDetail.current) {
      const mapped = datafilterReports.map((f) => ({
        ...f,
        value: f.multiple ? [] : null,
      }));
      setFilterReports(mapped);
      isFiltersInitializedDetail.current = true;
    }
  }, [datafilterReports]);

  // useEffect(() => {
  //   if (datafilters.length > 0) {
  //     const mapped = datafilters.map((f) => ({
  //       ...f,
  //       value: f.multiple ? [] : null,
  //     }));
  //     setFilters(mapped);
  //     // isFiltersInitialized.current = true;
  //   }
  // }, [datafilters]);

  useEffect(() => {
    dispatch(getMasterOrganisasi());
  }, []);

  useEffect(() => {
    if (
      datafilters.length > 0 &&
      datamasterOrganisasi?.length > 0 &&
      !isFiltersInitialized.current
    ) {
      const mapped = datafilters.map((f) => {
        let options = [];
        let isLoading = false;

        if (f.key === "organisasiPenanggungJawab") {
          options = datamasterOrganisasi.map((s) => ({
            label: s?.organization_name,
            value: s?.id,
          }));
          isLoading = isLoadingmasterOrganisasi;
        } else if (f.key === "is_bwc") {
          options = [
            { label: "Playback", value: true },
            { label: "Realtime", value: false },
          ];
        }

        return {
          ...f,
          value: f.multiple ? [] : null,
          options,
          isLoading,
        };
      });

      setFilters(mapped);
      isFiltersInitialized.current = true;
    }
  }, [datafilters, datamasterOrganisasi, isLoadingmasterOrganisasi]);

  const handleFilterReportChange = (key, newValue) => {
    setFilterReports((prev) =>
      prev.map((f) => (f.key === key ? { ...f, value: newValue } : f))
    );
  };
  const handleFilterChange = (key, newValue) => {
    setFilters((prev) =>
      prev.map((f) => (f.key === key ? { ...f, value: newValue } : f))
    );
  };

  return (
    <div>
      <div className="text-lg font-bold text-start gap-2 pb-5">
        <p
          className="text-2xl font-bold"
          style={{
            fontFamily: "Poppins",
          }}
        >
          Laporan Pemantauan
        </p>
      </div>
      <FilterCustemTable
        filtersConfig={datafilters}
        filters={filters?.length === 0 ? datafilters : filters}
        handleFilterChange={handleFilterChange}
        sxCustem={(f) =>
          f?.key === "tipePerangkat"
            ? 250
            : f?.key === "organisasiPenanggungJawab"
              ? 300
              : f?.key === "operasiKepolisian"
                ? 320
                : 160
        }
        onClickCreate={() => navigate(ROUTES.report.report_create)}
        isAction={isActionTableReport}
        onEditData={(data) =>
          navigate(ROUTES.report.report_update, {
            state: data,
          })
        }
        onClickShow={(data) => {
          navigate(`/report/detail/${data?.uuid}`, {
            state: data,
          });
          // setDetailData(data);
          // setOpenModal(!openModal);
        }}
        onDeleteData={(data) => {
          setUuid(data?.id);
          setDetailData(data);
          setOpenModalDelete(!openModalDelete);
        }}
        isLoading={data?.data === undefined ? true : isLoading}
        headerData={headerTableCustem}
        Data={data?.data || []}
        onSearchData={(keyword) => {
          setDataKeyword(keyword);
        }}
        rowsPerPage={pageSize}
        page={pageNumber}
        TablePagination={
          <TablePagination
            rowsPerPageOptions={[5, 15, 30, 50]}
            component="div"
            count={data?.totalItems || 0}
            rowsPerPage={pageSize}
            page={pageNumber}
            onPageChange={(event, newPage) => setPageNumber(newPage)}
            onRowsPerPageChange={(event) => {
              setPageSize(event.target.value, 10);
              setPageNumber(0);
            }}
          />
        }
      />
      {/* Modal Detail Data */}

      {/* Modal Confirm Delete */}
      <DraggableModal size="lg" open={openModalDelete} toggleModal={() => {}}>
        <DraggableModal.Header className="capitalize">
          <div className="flex gap-4 items-center justify-between">
            <p
              className="text-2xl font-bold"
              style={{
                fontFamily: "Poppins",
              }}
            >
              Hapus Data
            </p>
            <button
              className="h-10 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-xl font-semibold leading-6 text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={() => setOpenModalDelete(!openModalDelete)}
            >
              <i className="ri-close-line"></i>
            </button>
          </div>
        </DraggableModal.Header>
        <DraggableModal.Body>
          <div className="w-full text-lg font-bold text-start">
            <p
              className="text-md font-medium"
              style={{
                fontFamily: "Poppins",
              }}
            >
              Apakah Anda yakin ingin menghapus data ini ?
            </p>
          </div>
        </DraggableModal.Body>
        <DraggableModal.Footer>
          <div className="flex gap-4 items-center justify-end">
            <button
              className="h-11 flex w-auto justify-center items-center rounded-xl hover:bg-neutral-100 px-3 py-1.5 text-sm font-semibold leading-6 text-black  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
              onClick={() => setOpenModalDelete(!openModalDelete)}
            >
              Tutup
            </button>
            <button
              onClick={deleteData}
              className="h-11 flex w-auto justify-center items-center rounded-xl bg-rose-900 hover:bg-opacity-50 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
            >
              Hapus
            </button>
          </div>
        </DraggableModal.Footer>
      </DraggableModal>
    </div>
  );
}

export default Report;
